/* Вид полки: ДВА ВИДА и переключатель между ними.
 *
 * Замысел владельца 12.09.2026: делить не по устройству, а по человеку.
 * За компьютером сидит и мастер, ищущий по двенадцати признакам, и покупатель,
 * которому нужен холодильник. Ширина экрана про них ничего не говорит.
 *
 *   подробный — все характеристики полки, плотная сетка, страницы по 240,
 *               полный список брендов с поиском, скидка диапазонами, дерево;
 *   простой   — 8–12 главных характеристик, крупная сетка и «показать ещё»,
 *               десяток ходовых брендов, одна кнопка «со скидкой», путь
 *               вместо дерева, фильтры шторкой снизу с «Показать N товаров».
 *
 * Телефон — это простой вид на узком экране, а не отдельная работа.
 *
 * 🔴 Три условия, за которыми следит проверка `build/proverka_vidov.mjs`:
 *   1) числа в обоих видах совпадают: простой показывает меньше фильтров, но
 *      найденное по одному и тому же условию обязано быть тем же;
 *   2) выбор вида запоминается и переживает переходы;
 *   3) переключение не теряет выбранного: если в простом виде характеристики
 *      нет, фильтр не отменяется — он остаётся фишкой над списком.
 *
 * 🔴 Указатель грузится ОДИН и полный. Догрузки нет: замер 12.09.2026 показал,
 * что все 555 характеристик стоят 208 КБ gzip против 150 КБ у двенадцати —
 * делить ради веса нечего. Переключатель прячет и показывает, а не подгружает.
 *
 * 🔴 Ни одного обращения к нашему серверу. Карточка товара остаётся магазинной.
 */
(function () {
  'use strict';

  var E = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  /* Слова интерфейса. Язык берётся из магазина (request.locale), чего нет —
     английский: это основной язык витрины. Названия характеристик и их
     значения пока английские — так их отдаёт поставщик в указателе. */
  var SLOVA = {
    en: { reko: 'Recommended', vid_p: 'detailed', vid_s: 'simple', q_ph: 'Refine results', order: 'Sort', az: 'A–Z',
          by_stock: 'in stock', only_stock: 'In stock only', price: 'Price', disc: 'Discount',
          on_sale: 'on sale', cats: 'Categories', ustr: 'Devices', aks: 'Accessories', all_cats: 'All categories', brand: 'Brand',
          brand_ph: 'filter brands', less: '− less', more_n: '+ {n} more', more_f: '⚙ More filters',
          clear_all: '× clear all', items: 'products', filters: 'Filters',
          empty: 'Nothing found. Remove some filters.', on_order: 'on order',
          show_more: 'Show {n} more of {t}', back: '← Back', next: 'Next →', of: 'of', pg: 'p.',
          top: '↑ Top', hidden: 'filter from the detailed view: still applied', in_stock_tag: 'in stock',
          disc_tag: 'discount', m_head: 'More filters', m_search: 'Search filters', clear: 'Clear',
          apply: 'Apply', show_n: 'Show {n} products', loading: 'Loading…',
          fail: 'Could not load the filters ({e}). All products are available in the regular catalogue.',
          dept: 'Electronics' },
    ru: { reko: 'Рекомендуем', vid_p: 'подробный', vid_s: 'простой', q_ph: 'Уточнить в найденном', order: 'Порядок', az: 'А–Я',
          by_stock: 'в наличии', only_stock: 'Только в наличии', price: 'Цена', disc: 'Скидка',
          on_sale: 'со скидкой', cats: 'Разделы', ustr: 'Устройства', aks: 'Аксессуары', all_cats: 'Все разделы', brand: 'Бренд',
          brand_ph: 'фильтр брендов', less: '− свернуть', more_n: '+ еще {n}', more_f: '⚙ Еще фильтры',
          clear_all: '× сбросить все', items: 'товаров', filters: 'Фильтры',
          empty: 'Ничего не найдено. Снимите часть условий.', on_order: 'под заказ',
          show_more: 'Показать еще {n} из {t}', back: '← Назад', next: 'Далее →', of: 'из', pg: 'стр.',
          top: '↑ Наверх', hidden: 'фильтр из подробного вида: он в силе', in_stock_tag: 'в наличии',
          disc_tag: 'скидка', m_head: 'Еще фильтры', m_search: 'Поиск характеристики', clear: 'Сбросить',
          apply: 'Применить', show_n: 'Показать {n} товаров', loading: 'Загружаем…',
          fail: 'Фильтры не загрузились ({e}). Все товары доступны в обычном каталоге магазина.',
          dept: 'Электроника' },
    et: { reko: 'Soovitame', vid_p: 'detailne', vid_s: 'lihtne', q_ph: 'Täpsusta tulemusi', order: 'Järjestus', az: 'A–Z',
          by_stock: 'laos', only_stock: 'Ainult laos olevad', price: 'Hind', disc: 'Allahindlus',
          on_sale: 'soodushinnaga', cats: 'Kategooriad', ustr: 'Seadmed', aks: 'Tarvikud', all_cats: 'Kõik kategooriad', brand: 'Bränd',
          brand_ph: 'otsi brändi', less: '− vähem', more_n: '+ veel {n}', more_f: '⚙ Rohkem filtreid',
          clear_all: '× eemalda kõik', items: 'toodet', filters: 'Filtrid',
          empty: 'Midagi ei leitud. Eemalda mõni filter.', on_order: 'tellimisel',
          show_more: 'Näita veel {n} / {t}', back: '← Tagasi', next: 'Edasi →', of: '/', pg: 'lk',
          top: '↑ Üles', hidden: 'filter detailsest vaatest: kehtib', in_stock_tag: 'laos',
          disc_tag: 'allahindlus', m_head: 'Rohkem filtreid', m_search: 'Otsi filtrit', clear: 'Eemalda',
          apply: 'Rakenda', show_n: 'Näita {n} toodet', loading: 'Laadin…',
          fail: 'Filtrid ei laadinud ({e}). Kõik tooted on tavalises kataloogis.',
          dept: 'Elektroonika' }
  };
  SLOVA.de = { reko: 'Empfohlen', vid_p: 'detailliert', vid_s: 'einfach', q_ph: 'Ergebnisse eingrenzen', order: 'Sortierung', az: 'A–Z',
          by_stock: 'auf Lager', only_stock: 'Nur auf Lager', price: 'Preis', disc: 'Rabatt',
          on_sale: 'im Angebot', cats: 'Kategorien', ustr: 'Geräte', aks: 'Zubehör', all_cats: 'Alle Kategorien', brand: 'Marke',
          brand_ph: 'Marken filtern', less: '− weniger', more_n: '+ {n} weitere', more_f: '⚙ Weitere Filter',
          clear_all: '× alle entfernen', items: 'Produkte', filters: 'Filter',
          empty: 'Nichts gefunden. Entfernen Sie einige Filter.', on_order: 'auf Bestellung',
          show_more: '{n} weitere von {t} anzeigen', back: '← Zurück', next: 'Weiter →', of: 'von', pg: 'S.',
          top: '↑ Nach oben', hidden: 'Filter aus der Detailansicht: weiterhin aktiv', in_stock_tag: 'auf Lager',
          disc_tag: 'Rabatt', m_head: 'Weitere Filter', m_search: 'Filter suchen', clear: 'Entfernen',
          apply: 'Anwenden', show_n: '{n} Produkte anzeigen', loading: 'Wird geladen…',
          fail: 'Filter konnten nicht geladen werden ({e}). Alle Produkte finden Sie im normalen Katalog.',
          dept: 'Elektronik' };
  SLOVA.fr = { reko: 'Recommandés', vid_p: 'détaillé', vid_s: 'simple', q_ph: 'Affiner les résultats', order: 'Trier', az: 'A–Z',
          by_stock: 'en stock', only_stock: 'En stock uniquement', price: 'Prix', disc: 'Remise',
          on_sale: 'en promotion', cats: 'Catégories', ustr: 'Appareils', aks: 'Accessoires', all_cats: 'Toutes les catégories', brand: 'Marque',
          brand_ph: 'filtrer les marques', less: '− moins', more_n: '+ {n} de plus', more_f: '⚙ Plus de filtres',
          clear_all: '× tout effacer', items: 'produits', filters: 'Filtres',
          empty: 'Aucun résultat. Retirez quelques filtres.', on_order: 'sur commande',
          show_more: 'Afficher {n} de plus sur {t}', back: '← Précédent', next: 'Suivant →', of: 'sur', pg: 'p.',
          top: '↑ Haut', hidden: 'filtre de la vue détaillée: toujours actif', in_stock_tag: 'en stock',
          disc_tag: 'remise', m_head: 'Plus de filtres', m_search: 'Rechercher un filtre', clear: 'Effacer',
          apply: 'Appliquer', show_n: 'Afficher {n} produits', loading: 'Chargement…',
          fail: 'Impossible de charger les filtres ({e}). Tous les produits sont dans le catalogue habituel.',
          dept: 'Électronique' };
  SLOVA.nl = { reko: 'Aanbevolen', vid_p: 'uitgebreid', vid_s: 'eenvoudig', q_ph: 'Resultaten verfijnen', order: 'Sorteren', az: 'A–Z',
          by_stock: 'op voorraad', only_stock: 'Alleen op voorraad', price: 'Prijs', disc: 'Korting',
          on_sale: 'in de aanbieding', cats: 'Categorieën', ustr: 'Apparaten', aks: 'Accessoires', all_cats: 'Alle categorieën', brand: 'Merk',
          brand_ph: 'merken filteren', less: '− minder', more_n: '+ nog {n}', more_f: '⚙ Meer filters',
          clear_all: '× alles wissen', items: 'producten', filters: 'Filters',
          empty: 'Niets gevonden. Verwijder enkele filters.', on_order: 'op bestelling',
          show_more: 'Toon nog {n} van {t}', back: '← Vorige', next: 'Volgende →', of: 'van', pg: 'p.',
          top: '↑ Naar boven', hidden: 'filter uit de uitgebreide weergave: blijft actief', in_stock_tag: 'op voorraad',
          disc_tag: 'korting', m_head: 'Meer filters', m_search: 'Filter zoeken', clear: 'Wissen',
          apply: 'Toepassen', show_n: 'Toon {n} producten', loading: 'Laden…',
          fail: 'Filters konden niet worden geladen ({e}). Alle producten staan in de gewone catalogus.',
          dept: 'Elektronica' };
  SLOVA.no = { reko: 'Anbefalt', vid_p: 'detaljert', vid_s: 'enkel', q_ph: 'Avgrens resultatene', order: 'Sortering', az: 'A–Å',
          by_stock: 'på lager', only_stock: 'Bare på lager', price: 'Pris', disc: 'Rabatt',
          on_sale: 'på tilbud', cats: 'Kategorier', ustr: 'Enheter', aks: 'Tilbehør', all_cats: 'Alle kategorier', brand: 'Merke',
          brand_ph: 'filtrer merker', less: '− færre', more_n: '+ {n} til', more_f: '⚙ Flere filtre',
          clear_all: '× fjern alle', items: 'produkter', filters: 'Filtre',
          empty: 'Ingen treff. Fjern noen filtre.', on_order: 'bestillingsvare',
          show_more: 'Vis {n} til av {t}', back: '← Tilbake', next: 'Neste →', of: 'av', pg: 's.',
          top: '↑ Til toppen', hidden: 'filter fra detaljert visning: fortsatt aktivt', in_stock_tag: 'på lager',
          disc_tag: 'rabatt', m_head: 'Flere filtre', m_search: 'Søk etter filter', clear: 'Fjern',
          apply: 'Bruk', show_n: 'Vis {n} produkter', loading: 'Laster…',
          fail: 'Kunne ikke laste filtrene ({e}). Alle produkter finnes i den vanlige katalogen.',
          dept: 'Elektronikk' };
  SLOVA.es = { reko: 'Recomendados', vid_p: 'detallada', vid_s: 'sencilla', q_ph: 'Refinar resultados', order: 'Ordenar', az: 'A–Z',
          by_stock: 'en stock', only_stock: 'Solo en stock', price: 'Precio', disc: 'Descuento',
          on_sale: 'en oferta', cats: 'Categorías', ustr: 'Dispositivos', aks: 'Accesorios', all_cats: 'Todas las categorías', brand: 'Marca',
          brand_ph: 'filtrar marcas', less: '− menos', more_n: '+ {n} más', more_f: '⚙ Más filtros',
          clear_all: '× borrar todo', items: 'productos', filters: 'Filtros',
          empty: 'No se ha encontrado nada. Quita algunos filtros.', on_order: 'bajo pedido',
          show_more: 'Mostrar {n} más de {t}', back: '← Atrás', next: 'Siguiente →', of: 'de', pg: 'pág.',
          top: '↑ Arriba', hidden: 'filtro de la vista detallada: sigue aplicado', in_stock_tag: 'en stock',
          disc_tag: 'descuento', m_head: 'Más filtros', m_search: 'Buscar filtros', clear: 'Borrar',
          apply: 'Aplicar', show_n: 'Mostrar {n} productos', loading: 'Cargando…',
          fail: 'No se han podido cargar los filtros ({e}). Todos los productos están en el catálogo normal.',
          dept: 'Electrónica' };
  SLOVA.fi = { reko: 'Suosittelemme', vid_p: 'tarkka', vid_s: 'yksinkertainen', q_ph: 'Tarkenna tuloksia', order: 'Järjestys', az: 'A–Ö',
          by_stock: 'varastossa', only_stock: 'Vain varastossa', price: 'Hinta', disc: 'Alennus',
          on_sale: 'alennuksessa', cats: 'Kategoriat', ustr: 'Laitteet', aks: 'Tarvikkeet', all_cats: 'Kaikki kategoriat', brand: 'Merkki',
          brand_ph: 'suodata merkkejä', less: '− vähemmän', more_n: '+ {n} lisää', more_f: '⚙ Lisää suodattimia',
          clear_all: '× tyhjennä kaikki', items: 'tuotetta', filters: 'Suodattimet',
          empty: 'Mitään ei löytynyt. Poista joitakin suodattimia.', on_order: 'tilaustuote',
          show_more: 'Näytä {n} lisää ({t})', back: '← Takaisin', next: 'Seuraava →', of: '/', pg: 's.',
          top: '↑ Ylös', hidden: 'suodatin tarkasta näkymästä: edelleen käytössä', in_stock_tag: 'varastossa',
          disc_tag: 'alennus', m_head: 'Lisää suodattimia', m_search: 'Hae suodattimia', clear: 'Tyhjennä',
          apply: 'Käytä', show_n: 'Näytä {n} tuotetta', loading: 'Ladataan…',
          fail: 'Suodattimia ei voitu ladata ({e}). Kaikki tuotteet löytyvät tavallisesta luettelosta.',
          dept: 'Elektroniikka' };

  /* Значения характеристик поставщик не переводит (замер 13.10.2026 по полке
     phones: et и ru — 0 значений из 976, переведены только названия). Но треть
     всех значений у товаров — «Yes»/«No» (33 % из 169 516), дальше в основном
     числа. Поэтому самые частые слова переводим здесь, остальное — как есть. */
  var ZNACH = {
    'yes':   { de: 'Ja', et: 'Jah', fr: 'Oui', nl: 'Ja', no: 'Ja', ru: 'Да' },
    'no':    { de: 'Nein', et: 'Ei', fr: 'Non', nl: 'Nee', no: 'Nei', ru: 'Нет' },
    'n/a':   { de: 'k. A.', et: 'puudub', fr: 'n.d.', nl: 'n.v.t.', no: 'i/t', ru: 'нет данных' },
    'black': { de: 'Schwarz', et: 'Must', fr: 'Noir', nl: 'Zwart', no: 'Svart', ru: 'Черный' },
    'white': { de: 'Weiß', et: 'Valge', fr: 'Blanc', nl: 'Wit', no: 'Hvit', ru: 'Белый' },
    'grey':  { de: 'Grau', et: 'Hall', fr: 'Gris', nl: 'Grijs', no: 'Grå', ru: 'Серый' },
    'gray':  { de: 'Grau', et: 'Hall', fr: 'Gris', nl: 'Grijs', no: 'Grå', ru: 'Серый' },
    'silver':{ de: 'Silber', et: 'Hõbedane', fr: 'Argent', nl: 'Zilver', no: 'Sølv', ru: 'Серебристый' },
    'blue':  { de: 'Blau', et: 'Sinine', fr: 'Bleu', nl: 'Blauw', no: 'Blå', ru: 'Синий' },
    'red':   { de: 'Rot', et: 'Punane', fr: 'Rouge', nl: 'Rood', no: 'Rød', ru: 'Красный' },
    'green': { de: 'Grün', et: 'Roheline', fr: 'Vert', nl: 'Groen', no: 'Grønn', ru: 'Зеленый' },
    'gold':  { de: 'Gold', et: 'Kuldne', fr: 'Or', nl: 'Goud', no: 'Gull', ru: 'Золотистый' },
    'pink':  { de: 'Rosa', et: 'Roosa', fr: 'Rose', nl: 'Roze', no: 'Rosa', ru: 'Розовый' }
  };

  /* Названия, которых нет в переводе поставщика, а покупатель видит их первыми
     (замер 13.10.2026: среди первых 12 характеристик 14 полок без перевода
     чаще всего «Embeeded battery», «Warranty», «Type of battery»). Английское
     имя тоже правим: «Embeeded» — опечатка поставщика. */
  var NAZV = {
    'Embeeded battery': { en: 'Built-in battery', de: 'Eingebauter Akku', et: 'Sisseehitatud aku', fr: 'Batterie intégrée', nl: 'Ingebouwde accu', no: 'Innebygd batteri', ru: 'Встроенный аккумулятор' },
    'Warranty':         { de: 'Garantie', et: 'Garantii', fr: 'Garantie', nl: 'Garantie', no: 'Garanti', ru: 'Гарантия' },
    'Type of battery':  { de: 'Akkutyp', et: 'Aku tüüp', fr: 'Type de batterie', nl: 'Type accu', no: 'Batteritype', ru: 'Тип аккумулятора' },
    'Adjustable backrest': { de: 'Verstellbare Rückenlehne', et: 'Reguleeritav seljatugi', fr: 'Dossier réglable', nl: 'Verstelbare rugleuning', no: 'Justerbar ryggstø', ru: 'Регулируемая спинка' },
    'Adjustable arms':  { de: 'Verstellbare Armlehnen', et: 'Reguleeritavad käetoed', fr: 'Accoudoirs réglables', nl: 'Verstelbare armleuningen', no: 'Justerbare armlener', ru: 'Регулируемые подлокотники' },
    'Wireless':         { de: 'Kabellos', et: 'Juhtmevaba', fr: 'Sans fil', nl: 'Draadloos', no: 'Trådløs', ru: 'Беспроводной' },
    'Microphone':       { de: 'Mikrofon', et: 'Mikrofon', fr: 'Microphone', nl: 'Microfoon', no: 'Mikrofon', ru: 'Микрофон' },
    'Speed':            { de: 'Geschwindigkeit', et: 'Kiirus', fr: 'Vitesse', nl: 'Snelheid', no: 'Hastighet', ru: 'Скорость' },
    'Density':          { de: 'Dichte', et: 'Tihedus', fr: 'Densité', nl: 'Dichtheid', no: 'Tetthet', ru: 'Плотность' }
  };
  var EDIN = {
    'month(s)': { de: 'Monate', et: 'kuud', fr: 'mois', nl: 'maanden', no: 'måneder', ru: 'мес.' }
  };

  /* Перевод указателя на месте: названия и значения характеристик, имена
     разделов. Коды значений не меняются — меняются только подписи, поэтому
     счёт и адреса страниц остаются прежними. */
  function perevesti(doc, tr, lang) {
    lang = lang || 'en';
    // 🔴 Перевод привязан к порядку значений своей сборки. Указатель пересобран
    // без перевода (или наоборот) — подписи легли бы не к тем значениям.
    // Замер 13.10.2026: за полтора часа ушёл один товар, и у 23 из 555
    // характеристик полки appliances порядок значений сдвинулся.
    if (tr && tr.built !== doc.built) tr = null;
    doc.f.forEach(function (f, i) {
      // название: файл перевода → ручной словарь → как есть
      // (для en файл несёт выправленные имена: «Embeeded battery» → «Built-in battery»)
      f.e = f.e || f.n;                       // исходное английское имя: по нему выбраны главные фильтры полки
      var nz = NAZV[f.n];
      if (tr && tr.n && tr.n[i]) f.n = tr.n[i];
      else if (nz && nz[lang]) f.n = nz[lang];
      else if (nz && nz.en) f.n = nz.en;
      // единица: файл перевода (и для en: «pc(s)» → «pcs») → ручной словарь
      var ed = EDIN[f.u];
      if (tr && tr.u && tr.u[i]) f.u = tr.u[i];
      else if (lang !== 'en' && ed && ed[lang]) f.u = ed[lang];
      if (lang === 'en') return;
      f.v = f.v.map(function (v, j) {
        var t = tr && tr.fv && tr.fv[i] && tr.fv[i][j];
        if (t) return t;
        var z = ZNACH[String(v).trim().toLowerCase()];
        return (z && z[lang]) || v;
      });
    });
    // имена веток дерева ACC: файл перевода несёт их тем же порядком, что doc.kt
    if (doc.kt && tr && tr.kt) {
      doc.kt.forEach(function (u, i) { u[3] = u[1]; if (tr.kt[i]) u[1] = tr.kt[i]; });   // u[3] — имя en
    }
    if (tr && tr.subs) {
      doc.titles = doc.titles || {};
      doc.titles.subs = doc.titles.subs || {};
      for (var k in tr.subs) if (tr.subs[k]) doc.titles.subs[k] = tr.subs[k];
    }
  }

  var LANG = 'en';
  var T = function (k, a) {
    var s = (SLOVA[LANG] && SLOVA[LANG][k]) || SLOVA.en[k] || k;
    if (a) for (var x in a) s = s.replace('{' + x + '}', a[x]);
    return s;
  };

  /* 🔴 Цена в указателе — цена АДМИНКИ, без НДС рынка и в евро. Замер
     13.10.2026: эстонец видит её ×1,24, немец ×1,19, швед в кронах, у США
     свой множитель на каждый товар. Покупателю её показывать нельзя.
     Поэтому:
       * точную цену карточки браузер спрашивает у Shopify (Storefront API
         самого магазина, без ключа, с контекстом страны и языка) — это та же
         цена, что на карточке товара;
       * для порядка и диапазона цены служит указатель, переведённый в валюту
         покупателя множителем рынка. Множитель снимается с образцов: Liquid
         отдаёт цену нескольких товаров коллекции уже в контексте покупателя.
         Там, где он неточен (США), фильтр цены приблизителен, а цена на
         карточке всё равно точная. */
  var VALYUTA = 'EUR', MNOZH = null, FMT = null;
  var money = function (minor) {
    var v = minor / 100;
    try {
      if (!FMT) FMT = new Intl.NumberFormat(LANG, { style: 'currency', currency: VALYUTA,
                                                    minimumFractionDigits: 0, maximumFractionDigits: 2 });
      return FMT.format(v);
    } catch (e) { return v.toFixed(2) + ' ' + VALYUTA; }
  };
  // цена указателя → валюта покупателя (приблизительно)
  var vMestnuyu = function (baza) { return Math.round(baza * (MNOZH || 1)); };
  var izMestnoy = function (mest) { return Math.round(mest / (MNOZH || 1)); };

  // Кэш точных цен на всю жизнь страницы: ручка → ответ Shopify
  var CENY = {};

  var VIDY = { podrobnyy: 1, prostoy: 1 };
  // нейтральный значок «устройство» вместо заглушек магазина (см. bezFoto в zz-shelf-core.js)
  var IKONKA = '<svg viewBox="0 0 48 48" width="44" height="44" fill="none" stroke="currentColor" stroke-width="2.2" ' +
               'stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="9" width="34" height="23" rx="2.5"/>' +
               '<path d="M3 37h42M18 32l-2 5M30 32l2 5"/></svg>';
  var KLYUCH_VIDA = 'zz-vid';

  // Диапазоны скидки для подробного вида. В простом — одна кнопка «со скидкой».
  var SKIDKI = [[10, 19], [20, 29], [30, 39], [40, 49], [50, 100]];

  function ZZ(root, doc, opts) {
    this.root = root;
    this.sh = new window.ZZShelf.Shelf(doc);
    this.d = doc;
    this.opts = opts || {};
    if (this.opts.lang) LANG = SLOVA[this.opts.lang] ? this.opts.lang : 'en';
    if (this.opts.currency) VALYUTA = this.opts.currency;
    FMT = null;
    this.mnozhitel(this.opts.ref || []);
    this.debug = /[?&]debug=1/.test(location.search);
    this.prostye = doc.prostye || [];
    this.st = this.pustoe();
    this.sort = this.opts.sort || 'name';
    this.size = this.pomnit('zz-size') || 'm';
    this.page = 1;
    this.pokazano = 0;             // для «показать ещё» в простом виде
    this.brandQuery = '';
    this.brandOpen = false;
    this.shtorka = false;
    this.vid = this.vybratVid();
    this.readUrl();
    this.render();
    var self = this;
    window.addEventListener('popstate', function () {
      self.readUrl(); self.page = 1; self.pokazano = 0; self.render();
    });
  }

  /* Множитель рынка по образцам {h: ручка, p: цена в валюте покупателя, в
     сотых}. Берётся медиана: один товар с особой ценой не уводит всех. */
  ZZ.prototype.mnozhitel = function (ref) {
    var pos = {}, self = this, k = [];
    if (!ref.length) return;
    for (var i = 0; i < this.d.n; i++) pos[this.sh.handleAt(i)] = i;
    ref.forEach(function (r) {
      var i = pos[r.h];
      if (i != null && self.d.p[i] > 0 && r.p > 0) k.push(r.p / self.d.p[i]);
    });
    if (!k.length) return;
    k.sort(function (a, b) { return a - b; });
    MNOZH = k[k.length >> 1];
  };

  ZZ.prototype.pustoe = function () {
    return { facets: {}, brands: [], subs: [], kat: -1, sc: '', pmin: null, pmax: null,
             inStock: false, q: '', disc: null };
  };

  /* --- память: выбор вида переживает переходы ------------------------------ */
  ZZ.prototype.pomnit = function (k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      window.localStorage.setItem(k, v);
    } catch (e) { /* приватное окно — живём без памяти, но не падаем */ }
    return v;
  };

  ZZ.prototype.vybratVid = function () {
    // 15.10.2026, владелец со снимком телефона: «на мобильном в режиме detailed плохо меню работает» —
    // боковая колонка наезжала на товары. На узком экране — всегда простой вид (он для телефона и сделан:
    // ряд разделов сверху, фильтры в шторке), переключатель там спрятан (CSS).
    if ((window.innerWidth || 1200) < 900) return 'prostoy';
    // 1) адрес страницы (ссылку можно послать), 2) память, 3) ширина экрана
    var u = new URLSearchParams(location.search).get('vid');
    if (u && VIDY[u]) return u;
    var z = this.pomnit(KLYUCH_VIDA);
    if (z && VIDY[z]) return z;
    return (window.innerWidth || 1200) < 900 ? 'prostoy' : 'podrobnyy';
  };

  ZZ.prototype.smenitVid = function (v) {
    if (!VIDY[v] || v === this.vid) return;
    this.vid = v;
    this.pomnit(KLYUCH_VIDA, v);
    this.shtorka = false;
    this.page = 1;
    this.pokazano = 0;
    // 🔴 Выбранное НЕ сбрасываем. Если в простом виде характеристики нет,
    // фильтр остаётся и виден фишкой над списком — см. pickedChips().
    this.writeUrl(true);
    this.render();
  };

  /* --- какие характеристики показывает нынешний вид ------------------------ */
  ZZ.prototype.vidimyeFacety = function () {
    if (this.vid === 'podrobnyy') return this.d.f.map(function (_f, i) { return i; });
    return this.prostye.slice();
  };

  // Левая колонка подробного вида: фильтры, которые покупатель сам выбрал в окне «Больше фильтров»
  // (как у ACC: отметил названия → «Сохранить» → они слева, сверху), затем первые sideFacets по умолчанию.
  // Выбор помнится в браузере покупателя для этой полки (localStorage, без него — до перезагрузки).
  ZZ.prototype.dopKlyuch = function () { return 'zz-dop-' + (this.d.shelf || ''); };
  ZZ.prototype.dopFacety = function () {
    if (!this.dop) {
      this.dop = [];
      try { this.dop = JSON.parse(localStorage.getItem(this.dopKlyuch()) || '[]'); } catch (e) {}
      var d = this.d;
      this.dop = this.dop.filter(function (fi) { return d.f[fi]; });
    }
    return this.dop;
  };
  // Главные фильтры полки — по смыслу, вручную (слово владельца 16.10.2026 «да»; до того брались первые 8
  // по охвату, и у мониторов наверху стояли «Гарантия» и «Встроенный аккумулятор»). Имена — английские
  // исходные (f.e); чего на полке нет — пропускается. Владелец будет смотреть и править.
  var GLAVNYE = {"computers": ["Display diagonal", "Display", "Internal memory", "Total storage capacity", "Processor cores", "Discrete graphics adapter model", "Operating system installed", "Touchscreen", "Keyboard language"], "components": ["Component for", "Internal memory type", "Memory clock speed", "Solid-state drive capacity", "Hard drive capacity", "Processor socket", "Motherboard form factor", "Graphics processor family", "Nominal power"], "monitors-tv": ["Display diagonal (metric)", "Display", "Maximum refresh rate", "Panel type", "Response time", "Smart TV", "HDMI ports quantity", "Height adjustment", "USB-C"], "peripherals": ["Device type", "Connectivity technology", "Wireless connection", "Print technology", "Printing", "Duplex functions", "Maximum print size", "Keyboard layout", "UPS topology"], "networking": ["Wi-Fi band", "Ethernet LAN (RJ-45) ports", "Mesh Support", "POE", "Switch type", "Form factor", "Camera type", "Megapixel"], "phones": ["Internal storage capacity", "Internal RAM", "Display diagonal", "Operating system installed", "5G", "Main camera resolution", "SIM card capability", "Case type", "Brand compatibility"], "audio-photo": ["Wearing style", "Noise canceling", "Wireless connection", "Headphones connection type", "Microphone", "Output power", "Portable", "Waterproof"], "cables": ["Connector type", "Connector(s)", "Interface", "Gender", "Maximum cable length", "Cable type", "USB version", "Maximum resolution"], "appliances": ["Device type", "Product type", "Energy efficiency class", "Cordless", "Number of programs", "Maximum spin speed", "No Frost system", "Number of burners/cooking zones", "Number of speeds"], "home-garden": ["Bulb type", "Fitting/cap type", "Colour temperature", "Dimmable", "IP class", "Power supply voltage", "Battery capacity", "Supported network protocols"], "office-software": ["Product type", "License type", "Number of device", "Number of years", "Shredder type", "Security level", "Language version", "Platform"], "lifestyle": ["Type", "Product type", "Material", "Size", "Capacity", "Speed", "Wheel size", "Season"], "gaming": ["Device type", "Type", "Gaming platforms supported", "Wireless connection", "RGB LED light", "Adjustable backrest", "Wearing style", "Keyboard layout"]};
  ZZ.prototype.standartFacety = function () {
    var g = GLAVNYE[this.d.shelf];
    if (g) {
      var idx = {};
      this.d.f.forEach(function (f, i) { idx[f.e || f.n] = i; });
      var out = g.map(function (n) { return idx[n]; }).filter(function (i) { return i !== undefined; });
      if (out.length) return out;
    }
    // 16.10.2026, слово владельца: фильтры слева в подробном виде «основные и нормальные», а в простом
    // была другая, непонятная система. Теперь шторка простого вида = левая колонка подробного: тот же набор.
    return this.d.f.map(function (_f, i) { return i; }).slice(0, this.opts.sideFacets || 8);
  };
  ZZ.prototype.sbokFacety = function () {
    var out = this.dopFacety().slice();
    this.standartFacety().forEach(function (fi) { if (out.indexOf(fi) < 0) out.push(fi); });
    return out;
  };

  ZZ.prototype.facetSkryta = function (fi) {
    if (this.vid === 'podrobnyy') return false;          // в подробном виде любой фильтр доступен через окно
    return this.sbokFacety().indexOf(+fi) < 0;
  };

  /* --- состояние в адресе страницы ----------------------------------------- */
  ZZ.prototype.readUrl = function () {
    var u = new URLSearchParams(location.search);
    this.st = this.pustoe();
    var self = this;
    u.forEach(function (v, k) {
      if (k.slice(0, 2) === 'f_') {
        var fi = +k.slice(2);
        if (self.d.f[fi]) self.st.facets[fi] = v.split('.').map(Number).filter(Boolean);
      }
    });
    if (u.get('b')) this.st.brands = u.get('b').split('.').map(Number);
    if (u.get('s')) this.st.subs = u.get('s').split('.').map(Number);
    if (u.get('k') && this.d.kt && this.d.kt[+u.get('k')]) this.st.kat = +u.get('k');
    if (u.get('sc') && window.ZZ_SCEN && window.ZZ_SCEN[u.get('sc')]) this.st.sc = u.get('sc');
    // крупный раздел меню мира (ZZ_SCEN[...].s — ручки полок): подборка = эти полки отдела
    var scS = this.st.sc && window.ZZ_SCEN[this.st.sc].s;
    if (scS && this.d.subs && !this.st.subs.length) {
      var subs = this.d.subs;
      this.st.subs = scS.map(function (h) { return subs.indexOf(h); }).filter(function (i) { return i >= 0; });
    }
    // kb=<branch_id ACC>: так ссылаются плитки и меню отдела (номер узла у каждой полки свой)
    if (u.get('kb') && this.d.kt) {
      for (var ub = 0; ub < this.d.kt.length; ub++) if (String(this.d.kt[ub][2]) === u.get('kb')) { this.st.kat = ub; break; }
    }
    if (u.get('pmin')) this.st.pmin = +u.get('pmin');
    if (u.get('pmax')) this.st.pmax = +u.get('pmax');
    if (u.get('stock')) this.st.inStock = true;
    if (u.get('disc')) this.st.disc = u.get('disc').split('-').map(Number);
    if (u.get('q')) this.st.q = u.get('q');
    if (u.get('sort')) this.sort = u.get('sort');
    if (u.get('page')) this.page = Math.max(1, +u.get('page'));
    if (u.get('vid') && VIDY[u.get('vid')] && (window.innerWidth || 1200) >= 900) this.vid = u.get('vid');
  };

  // Свои ключи адреса. Чужие (view=zz-shelf, preview_theme_id, debug…) переносятся
  // как были: без view=zz-shelf обновление страницы открыло бы обычную коллекцию.
  var SVOI = /^(f_\d+|b|s|k|kb|sc|pmin|pmax|stock|disc|q|sort|page|vid)$/;

  ZZ.prototype.writeUrl = function (push) {
    var u = new URLSearchParams();
    new URLSearchParams(location.search).forEach(function (v, k) { if (!SVOI.test(k)) u.set(k, v); });
    for (var fi in this.st.facets) {
      if (this.st.facets[fi] && this.st.facets[fi].length) u.set('f_' + fi, this.st.facets[fi].join('.'));
    }
    if (this.st.brands.length) u.set('b', this.st.brands.join('.'));
    if (this.st.subs.length) u.set('s', this.st.subs.join('.'));
    if (this.st.kat >= 0) u.set('k', this.st.kat);
    if (this.st.sc) u.set('sc', this.st.sc);
    if (this.st.pmin != null) u.set('pmin', this.st.pmin);
    if (this.st.pmax != null) u.set('pmax', this.st.pmax);
    if (this.st.inStock) u.set('stock', '1');
    if (this.st.disc) u.set('disc', this.st.disc.join('-'));
    if (this.st.q) u.set('q', this.st.q);
    if (this.sort !== (this.opts.sort || 'name')) u.set('sort', this.sort);
    if (this.page > 1) u.set('page', this.page);
    u.set('vid', this.vid);
    var url = location.pathname + '?' + u.toString();
    try { history[push ? 'pushState' : 'replaceState']({}, '', url); } catch (e) {}
  };

  ZZ.prototype.apply = function () {
    this.page = 1; this.pokazano = 0; this.writeUrl(true); this.render();
  };

  /* --- счёт ---------------------------------------------------------------- */
  ZZ.prototype.uslovie = function () {
    // Условие отбора НЕ зависит от вида — в этом весь смысл первого условия.
    var st = this.st, d = this.d, s = {
      facets: st.facets, brands: st.brands, subs: st.subs, kat: st.kat, kats: this.scUzly(),
      pmin: st.pmin, pmax: st.pmax, inStock: st.inStock, q: st.q
    };
    // считаем числа только у тех характеристик, что видны сейчас
    s.facetsToCount = this.schitatFacety();
    if (st.disc) {
      var lo = st.disc[0], hi = st.disc[1];
      s.extra = { ids: ['disc'], test: function (i) { return d.d[i] >= lo && d.d[i] <= hi; } };
    }
    return s;
  };

  /* Какие характеристики нужно пересчитать для нынешнего экрана.
     Окно «Ещё фильтры» показывает все — тогда считаем все. */
  ZZ.prototype.schitatFacety = function () {
    if (this.vseFacety) return undefined;          // undefined = считать все
    return this.sbokFacety();
  };

  ZZ.prototype.render = function () {
    var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
    var res = this.sh.run(this.uslovie());
    var tCount = ((window.performance && performance.now) ? performance.now() : Date.now()) - t0;
    this.res = res;
    var hits = this.sh.sort(res.hits, this.sort);
    this.hits = hits;
    this.root.className = 'zz-vid-' + this.vid + (this.debug ? ' zz-debug' : '');
    this.root.innerHTML =
      this.perekl() +
      '<div class=zz-layout>' + (this.vid === 'podrobnyy' ? this.side(res) : '') +
      this.main(hits, res) + '</div>' +
      (this.vid === 'podrobnyy' ? this.modal() : this.shtorkaHtml(res) + this.katShtorkaHtml(res) + this.modal());
    this.bind();
    var dbg = this.root.querySelector('.zz-dbg');
    if (dbg) dbg.textContent = 'пересчет ' + tCount.toFixed(1) + ' мс · множитель ' +
                                (MNOZH ? MNOZH.toFixed(4) : 'нет') + ' ' + VALYUTA;
    this.ceny();
  };

  /* --- точные цены видимых карточек у Shopify ------------------------------- */
  ZZ.prototype.ceny = function () {
    var self = this, need = [];
    Array.prototype.forEach.call(this.root.querySelectorAll('.zz-card[data-h]'), function (el) {
      var h = el.getAttribute('data-h');
      if (CENY[h]) self.primenit(el, CENY[h]);
      else if (CENY[h] !== false && need.indexOf(h) < 0) need.push(h);
    });
    if (!need.length || !this.opts.sfApi) return;
    for (var i = 0; i < need.length; i += 40) this.zaprosCen(need.slice(i, i + 40));
  };

  ZZ.prototype.zaprosCen = function (handles) {
    var self = this, o = this.opts, parts = [];
    handles.forEach(function (h, i) {
      CENY[h] = false;        // в пути: второй раз не спрашиваем
      parts.push('p' + i + ':product(handle:' + JSON.stringify(h) + '){title availableForSale ' +
                 'priceRange{minVariantPrice{amount currencyCode}} ' +
                 'compareAtPriceRange{maxVariantPrice{amount}}}');
    });
    var ctx = [];
    if (o.country) ctx.push('country:' + o.country);
    if (o.sfLang) ctx.push('language:' + o.sfLang);
    var q = 'query' + (ctx.length ? ' @inContext(' + ctx.join(',') + ')' : '') + '{' + parts.join(' ') + '}';
    fetch(o.sfApi, { method: 'POST', credentials: 'omit',
                     headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                     body: JSON.stringify({ query: q }) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var data = (j && j.data) || {};
        handles.forEach(function (h, i) {
          var x = data['p' + i];
          if (!x) { delete CENY[h]; return; }
          var mp = x.priceRange && x.priceRange.minVariantPrice;
          var ca = x.compareAtPriceRange && x.compareAtPriceRange.maxVariantPrice;
          CENY[h] = { t: x.title, a: x.availableForSale,
                      p: mp ? Math.round(parseFloat(mp.amount) * 100) : null,
                      cur: mp ? mp.currencyCode : null,
                      ca: ca ? Math.round(parseFloat(ca.amount) * 100) : 0 };
        });
        Array.prototype.forEach.call(self.root.querySelectorAll('.zz-card[data-h]'), function (el) {
          var c = CENY[el.getAttribute('data-h')];
          if (c) self.primenit(el, c);
        });
      })
      .catch(function () {
        // Не ответил — остаётся приблизительная цена с пометкой «≈»
        handles.forEach(function (h) { delete CENY[h]; });
      });
  };

  ZZ.prototype.primenit = function (el, c) {
    if (c.p == null) return;
    if (c.cur && c.cur !== VALYUTA) { VALYUTA = c.cur; FMT = null; }
    var pr = el.querySelector('.zz-price');
    if (pr) pr.innerHTML = E(money(c.p)) + (c.a ? '' : ' <span class=zz-mut>· ' + E(T('on_order')) + '</span>');
    var tt = el.querySelector('.zz-title');
    if (tt && c.t && tt.textContent !== c.t) tt.textContent = c.t;
    var bd = el.querySelector('.zz-badge');
    var pct = c.ca > c.p && c.p > 0 ? Math.round((c.ca - c.p) / c.ca * 100) : 0;
    if (pct && !bd) { bd = document.createElement('span'); bd.className = 'zz-badge'; el.insertBefore(bd, el.firstChild); }
    if (bd) { if (pct) bd.textContent = '−' + pct + ' %'; else bd.parentNode.removeChild(bd); }
  };

  /* --- переключатель видов -------------------------------------------------- */
  ZZ.prototype.perekl = function () {
    var self = this;
    // 15.10.2026: переключатель вида живёт в строке «N товаров» (vidSw), а верхняя строка —
    // только путь к выбранной ветке; нет пути — нет и строки (была пустая полоса над товарами)
    var put = this.putHtml();
    return put ? '<div class=zz-topbar><div class=zz-path>' + put + '</div></div>' : '';
  };
  ZZ.prototype.sortSel = function () {
    var zn = E(money(0).replace(/[\d\s.,\u00a0]/g, '') || VALYUTA), self = this;
    var h = ['<label class=zz-sortsel><span class=zz-mut>' + E(T('order')) + ':</span> <select class=zz-sortv>'];
    [['glavnoe', E(T('reko'))], ['name', E(T('az'))], ['priceasc', zn + ' ↑'], ['pricedesc', zn + ' ↓'], ['stock', E(T('by_stock'))]].forEach(function (s) {
      h.push('<option value="' + s[0] + '"' + (self.sort === s[0] ? ' selected' : '') + '>' + s[1] + '</option>');
    });
    h.push('</select></label>');
    return h.join('');
  };
  ZZ.prototype.vidSw = function () {
    var self = this, h = ['<div class=zz-vidsw>'];
    ['prostoy', 'podrobnyy'].forEach(function (v) {
      h.push('<button class="zz-chip zz-vidbtn' + (self.vid === v ? ' act' : '') + '" data-v="' + v + '">' +
             E(T(v === 'prostoy' ? 'vid_s' : 'vid_p')) + '</button>');
    });
    h.push('</div>');
    return h.join('');
  };

  /* --- путь вместо дерева (в простом виде — главный способ ориентации) ------ */
  ZZ.prototype.putHtml = function () {
    var d = this.d, t = d.titles || {}, h = [];
    // Меню полок сверху уже даёт и отдел, и полку: путь нужен, только когда выбрана ветка
    if (this.opts.menu && !(d.kt && this.st.kat >= 0) && !this.st.subs.length && !this.st.sc) return '';
    if (this.opts.deptUrl && !this.opts.menu) {
      h.push('<a class=zz-krumb href="' + E(this.opts.deptUrl) + '">' + E(this.opts.deptTitle || T('dept')) +
             '</a><span class=zz-sep>›</span>');
    }
    h.push('<button class="zz-krumb zz-suball' + (d.kt ? ' zz-katall' : '') + '">' + E(this.opts.title || t.shelf || d.shelf) + '</button>');
    var self = this;
    if (this.st.sc && window.ZZ_SCEN && window.ZZ_SCEN[this.st.sc]) {   // сценарий — ступенью пути с ✕
      h.push('<span class=zz-sep>›</span><button class="zz-krumb' + (this.st.kat >= 0 ? '' : ' act') +
             '" data-scx=1>' + E(window.ZZ_SCEN[this.st.sc].t) + ' <span class=zz-kx aria-hidden=true>✕</span></button>');
    }
    if (d.kt) {                       // дерево ACC: путь до выбранной ветки, каждая ступень — ссылка вверх
      this.putVetki().forEach(function (u, j, all) {
        var last = j === all.length - 1;
        h.push('<span class=zz-sep>›</span><button class="zz-krumb' + (last ? ' act' : '') + '" data-kat="' +
               (last ? d.kt[u][0] : u) + '">' + E(d.kt[u][1]) + (last ? ' <span class=zz-kx aria-hidden=true>✕</span>' : '') + '</button>');
      });
      return h.join('');
    }
    this.st.subs.forEach(function (i) {
      var handle = d.subs[i];
      h.push('<span class=zz-sep>›</span><button class="zz-krumb act" data-s="' + i + '">' +
             E((t.subs && t.subs[handle]) || handle) + ' <span class=zz-kx aria-hidden=true>✕</span></button>');
    });
    return h.join('');
  };

  /* --- боковая панель (только подробный вид) -------------------------------- */
  ZZ.prototype.side = function (res) {
    var d = this.d, st = this.st, h = [];
    h.push('<aside class=zz-side>');
    h.push('<div class=zz-box><input class="zz-inp zz-q" placeholder="' + E(T('q_ph')) + '" value="' + E(st.q) + '"></div>');

    // 15.10.2026 (обход юзабилити): разделы — первыми, это главная навигация полки; сортировка —
    // в строке над товарами (sortSel), левая колонка — только отбор
    h.push(this.derevoBox(res));
    h.push('<div class=zz-box><button class="zz-avail' + (st.inStock ? ' on' : '') + '">' +
           (st.inStock ? '✓ ' : '') + E(T('only_stock')) + ' <span class=zz-mut>(' + res.inStockCount + ')</span></button></div>');

    h.push(this.cenaBox(res));
    h.push(this.skidkaBox(true));
    h.push(this.brendBox(res, 12, true));

    var vis = this.vidimyeFacety(), sbok = this.sbokFacety();
    sbok.forEach(function (fi) { h.push(this.facetBox(fi, res)); }, this);
    var rest = d.f.length - sbok.length;
    h.push('<div class=zz-box><button class=zz-more>' + E(T('more_f')) +
           (rest > 0 ? ' <span class=zz-mut>(' + rest + ')</span>' : '') + '</button>' +
           (this.hasAny() ? '<button class="zz-chip zz-reset">' + E(T('clear_all')) + '</button>' : '') + '</div>');
    h.push('<div class="zz-mut zz-dbg"></div>');
    h.push('</aside>');
    return h.join('');
  };

  ZZ.prototype.cenaBox = function (res) {
    var st = this.st;
    var lo = st.pmin != null ? st.pmin : res.priceMin;
    var hi = st.pmax != null ? st.pmax : res.priceMax;
    // В адресе и в условии — цена указателя; на экране — валюта покупателя.
    return '<div class=zz-box><div class=zz-lbl>' + E(T('price')) + ', ' + E(VALYUTA) +
      (MNOZH ? '' : ' ≈') + '</div><div class=zz-prow>' +
      '<input class="zz-inp zz-pmin" inputmode=numeric value="' + Math.floor(vMestnuyu(lo) / 100) + '">' +
      '<span class=zz-mut>-</span>' +
      '<input class="zz-inp zz-pmax" inputmode=numeric value="' + Math.ceil(vMestnuyu(hi) / 100) + '">' +
      '<button class=zz-chip id=zz-pgo>OK</button></div></div>';
  };

  /* Скидка: в подробном виде диапазонами, в простом — одной кнопкой.
     Числа у диапазонов считаются по тому же набору условий, что и выдача. */
  ZZ.prototype.skidkaBox = function (diapazony) {
    var d = this.d, st = this.st, self = this, h = [];
    var est = this.d.d.some(function (x) { return x > 0; });
    if (!est) return '';
    h.push('<div class=zz-box><div class=zz-lbl>' + E(T('disc')) + '</div><div class=zz-chips>');
    if (!diapazony) {
      var on = !!st.disc;
      h.push('<button class="zz-chip zz-disc' + (on ? ' act' : '') + '" data-lo=1 data-hi=100>' +
             (on ? '✓ ' : '') + E(T('on_sale')) + ' <span class=zz-mut>(' + this.skolkoSoSkidkoy(1, 100) + ')</span></button>');
    } else {
      SKIDKI.forEach(function (r) {
        var act = st.disc && st.disc[0] === r[0] && st.disc[1] === r[1];
        var n = self.skolkoSoSkidkoy(r[0], r[1]);
        if (!n && !act) return;
        h.push('<button class="zz-chip zz-disc' + (act ? ' act' : '') + '" data-lo="' + r[0] + '" data-hi="' + r[1] + '">' +
               r[0] + '–' + r[1] + ' % <span class=zz-mut>(' + n + ')</span></button>');
      });
    }
    h.push('</div></div>');
    return h.join('');
  };

  /* Сколько останется, если добавить условие «скидка от lo до hi».
     Считается по живому набору — заранее сохранённое число здесь соврало бы. */
  ZZ.prototype.skolkoSoSkidkoy = function (lo, hi) {
    var d = this.d;
    var s = this.uslovie();
    s = JSON.parse(JSON.stringify({ facets: s.facets, brands: s.brands, subs: s.subs, kat: s.kat, kats: s.kats,
                                    pmin: s.pmin, pmax: s.pmax, inStock: s.inStock, q: s.q }));
    s.extra = { ids: ['disc'], test: function (i) { return d.d[i] >= lo && d.d[i] <= hi; } };
    return this.sh.run(s).total;
  };

  /* --- дерево ACC (слово владельца 15.10.2026, образец catalog.alfieristock.eu) -------- */
  // Общие ветки ACC («Accessories», «Others») покупателю ничего не говорят: в списках они
  // раскрываются в своих детей, в пути пропускаются. Слово владельца 15.10.2026: «перебор».
  var OBSHCHIE = /^(Accessories|Others?)$/;
  ZZ.prototype.obshchaya = function (u) {
    var k = this.d.kt[u];
    return k[0] < 0 || OBSHCHIE.test(k[3] || k[1]);   // корень ACC или «Accessories»
  };
  // узлы веток сценария (branch_id → номер узла этого указателя)
  ZZ.prototype.scUzly = function () {
    var sc = this.st.sc && window.ZZ_SCEN && window.ZZ_SCEN[this.st.sc], d = this.d, out = [];
    if (!sc || !d.kt) return [];
    for (var u = 0; u < d.kt.length; u++) if (sc.b.indexOf(d.kt[u][2]) >= 0) out.push(u);
    return out;
  };
  ZZ.prototype.putVetki = function () {      // от корня до выбранной ветки, только понятные ступени
    var d = this.d, put = [], u = this.st.kat, vid = {};
    while (u >= 0 && d.kt[u] && !vid[u]) { vid[u] = 1; put.unshift(u); u = d.kt[u][0]; }
    var self = this, last = put[put.length - 1];
    return put.filter(function (x) { return x === last || !self.obshchaya(x); });
  };
  // Что внутри нынешней ветки. Обход полок 15.10.2026 (слово владельца «тут перебор»; «телефоны —
  // это не чехлы»):
  //  · корни ACC и «Accessories/Others» раскрываются в детей; ветка, где больше 60 % выдачи, — тоже
  //    («Бытовая техника» иначе давала два пункта: Small 2 937 и Major 965);
  //  · одно имя из параллельных деревьев ACC — один пункт (больший); сравнение без пробелов и знаков
  //    («Powerbanks» = «Power banks»);
  //  · «Others» и ветки меньше 1 % выдачи при числе меньше 5 не показываются;
  //  · пункты делятся на «Устройства» и «Аксессуары» (предок с именем Accessories), если обе группы
  //    не меньше 10 % — иначе один список (у «Кабелей» почти всё — аксессуары, деление пустое).
  ZZ.prototype.detiVetki = function (res) {
    var d = this.d, k = this.st.kat, self = this, total = res.total || 1;
    var en = function (u) { return d.kt[u][3] || d.kt[u][1]; };
    var deti = function (p) {
      var r = [];
      for (var u = 0; u < d.kt.length; u++) if (d.kt[u][0] === p) r.push(u);
      return r;
    };
    var podAks = function (u) {
      for (var x = d.kt[u][0]; x >= 0; x = d.kt[x][0]) if (en(x) === 'Accessories') return true;
      return false;
    };
    var norm = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9\u00c0-\u024f\u0400-\u04ff]/g, ''); };
    var ochered = deti(k), vid = {}, poImeni = {}, out = [];
    while (ochered.length) {
      var u = ochered.shift();
      if (vid[u] || !(res.katCounts[u] > 0)) continue;
      vid[u] = 1;
      var c = res.katCounts[u], dd = deti(u);
      if (dd.length && (self.obshchaya(u) || c > total * 0.6)) { ochered = ochered.concat(dd); continue; }
      if (/^others?$/i.test(en(u))) continue;
      if (c < 5 && c < total * 0.01) continue;
      // одноимённые техника и аксессуар к ней — разные пункты (раскладка по смыслу 16.10.2026)
      var aU = podAks(u) || en(u) === 'Accessories', key = norm(d.kt[u][1]) + (aU ? '|a' : ''), was = poImeni[key];
      if (was && was.c >= c) continue;
      if (was) out.splice(out.indexOf(was), 1);
      poImeni[key] = { u: u, n: d.kt[u][1], c: c, a: aU };
      out.push(poImeni[key]);
    }
    out.sort(function (a, b) { return b.c - a.c || (a.n < b.n ? -1 : 1); });
    var dev = out.filter(function (x) { return !x.a; }), aks = out.filter(function (x) { return x.a; });
    var sumD = dev.reduce(function (s, x) { return s + x.c; }, 0), sumA = aks.reduce(function (s, x) { return s + x.c; }, 0);
    var razd = dev.length && aks.length && sumD >= 0.1 * (sumD + sumA) && sumA >= 0.1 * (sumD + sumA);
    out.razd = razd; out.dev = dev; out.aks = aks;
    return out;
  };

  // Ряд разделов над товарами: что внутри нынешней ветки. Один-единственный ребёнок,
  // в котором всё то же самое, ряд не показывает — выбирать нечего.
  ZZ.prototype.katNav = function (res) {
    var d = this.d;
    if (!d.kt || this.vid !== 'prostoy') return '';   // в подробном виде разделы — слева
    // крупный раздел меню мира (несколько полок): вместо 70 мелких веток — его полки, каждая ведёт на свою страницу
    var scS = this.st.sc && window.ZZ_SCEN && window.ZZ_SCEN[this.st.sc] && window.ZZ_SCEN[this.st.sc].s;
    if (scS && d.subs) {
      var self = this, hp = ['<div class="zz-katnav zz-katnav-polki">'], koren = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      scS.forEach(function (hnd) {
        var i = d.subs.indexOf(hnd);
        if (i < 0 || !res.subCounts[i]) return;
        hp.push('<a class="zz-chip zz-katbtn" href="' + koren + 'collections/' + hnd + '?view=zz-shelf">' + E(self.imyaRazdela(hnd)) +
                ' <span class=zz-mut>' + res.subCounts[i] + '</span></a>');
      });
      hp.push('</div>');
      return hp.join('');
    }
    var deti = this.detiVetki(res);
    if (!deti.length || (deti.length === 1 && deti[0].c === res.total)) return '';
    // Слово владельца 15.10.2026 (снимок с телефона): «чипы 2 группы и мало понятно что есть что».
    // Как у больших магазинов: две вкладки «Устройства | Аксессуары» и под ними ОДИН ряд
    // выбранной группы; на телефоне ряд листается вбок, а не стеной в 30 кнопок.
    var gr = deti.razd ? (this.katGr === 'a' ? 'a' : 'd') : '', h = [];
    if (deti.razd) {
      h.push('<div class=zz-kattabs role=tablist>' +
             '<button class="zz-kattab' + (gr === 'd' ? ' act' : '') + '" data-kg=d role=tab>' + E(T('ustr')) + '</button>' +
             '<button class="zz-kattab' + (gr === 'a' ? ' act' : '') + '" data-kg=a role=tab>' + E(T('aks')) + '</button></div>');
    }
    h.push('<div class=zz-katnav>');
    (gr === 'a' ? deti.aks : gr === 'd' ? deti.dev : deti).forEach(function (x) {
      h.push('<button class="zz-chip zz-katbtn" data-kat="' + x.u + '">' + E(x.n) +
             ' <span class=zz-mut>' + x.c + '</span></button>');
    });
    h.push('</div>');
    return h.join('');
  };

  ZZ.prototype.derevoBox = function (res) {
    var d = this.d, st = this.st, t = d.titles || {}, h = [];
    if (d.kt) {
      h.push('<div class=zz-box><div class=zz-lbl>' + E(T('cats')) + '</div><div class="zz-tree zz-tree-kat">');
      h.push('<button class="zz-row zz-katall' + (st.kat >= 0 ? '' : ' act') + '" data-kat="-1">' +
             '<span>' + E(T('all_cats')) + '</span></button>');
      var put = this.putVetki();
      put.forEach(function (u, j) {
        h.push('<button class="zz-row zz-kat' + (j === put.length - 1 ? ' act' : '') + '" data-kat="' + u + '" style="padding-left:' + (8 + 12 * (j + 1)) + 'px">' +
               '<span>' + E(d.kt[u][1]) + '</span><span class=zz-mut>' + res.katCounts[u] + '</span></button>');
      });
      var dt = this.detiVetki(res), otst = 8 + 12 * (put.length + 1), self = this;
      // в группе больше 10 пунктов — остальные под кнопкой «ещё N» (у «Дом и сад» было 27)
      var gruppa = function (spisok, imya) {
        var otkr = self.katOtkr && self.katOtkr[imya];
        spisok.forEach(function (x, i) {
          h.push('<button class="zz-row zz-kat" data-kat="' + x.u + '" style="padding-left:' + otst + 'px">' +
                 '<span>' + E(x.n) + '</span><span class=zz-mut>' + x.c + '</span></button>');
        });
      };
      if (dt.razd) {
        h.push('<div class=zz-katgr>' + E(T('ustr')) + '</div>'); gruppa(dt.dev, 'd');
        h.push('<div class=zz-katgr>' + E(T('aks')) + '</div>'); gruppa(dt.aks, 'a');
      } else gruppa(dt, 'v');
      h.push('</div></div>');
      return h.join('');
    }
    if (!d.subs || !d.subs.length) return '';
    h.push('<div class=zz-box><div class=zz-lbl>' + E(T('cats')) + '</div><div class=zz-tree>');
    h.push('<button class="zz-row zz-suball' + (st.subs.length ? '' : ' act') + '">' +
           '<span>' + E(T('all_cats')) + '</span><span class=zz-mut>' + d.n + '</span></button>');
    d.subs.forEach(function (name, i) {
      if (!res.subCounts[i] && st.subs.indexOf(i) < 0) return;
      var on = st.subs.indexOf(i) >= 0;
      h.push('<button class="zz-row zz-sub' + (on ? ' act' : '') + '" data-i="' + i + '">' +
             '<span>' + E(this.imyaRazdela(name)) + '</span>' +
             '<span class=zz-mut>' + res.subCounts[i] + '</span></button>');
    }, this);
    h.push('</div></div>');
    return h.join('');
  };

  ZZ.prototype.imyaRazdela = function (handle) {
    var o = this.opts.subTitles, t = this.d.titles;
    return (o && o[handle]) || (t && t.subs && t.subs[handle]) || handle;
  };

  ZZ.prototype.brendBox = function (res, skolko, spoiskom) {
    var d = this.d, st = this.st, h = [];
    var bl = d.brands.map(function (b, i) { return { i: i, b: b, c: res.brandCounts[i] }; })
                     .filter(function (x) { return x.c > 0 || st.brands.indexOf(x.i) >= 0; });
    if (spoiskom && this.brandQuery) {
      var bq = this.brandQuery.toLowerCase();
      bl = bl.filter(function (x) { return x.b.toLowerCase().indexOf(bq) >= 0; });
    }
    bl.sort(function (a, b) { return b.c - a.c || (a.b < b.b ? -1 : 1); });
    // 16.10.2026 (снимок владельца «какой смысл в этой кнопке +84»): список и так прокручивается —
    // показываем все бренды с прокруткой и поиском, без кнопки «ещё N».
    var shown = bl;
    h.push('<div class=zz-box><div class=zz-lbl>' + E(T('brand')) + '</div>');
    if (spoiskom) h.push('<input class="zz-inp zz-bq" placeholder="' + E(T('brand_ph')) + '" value="' + E(this.brandQuery) + '">');
    h.push('<div class=zz-tree>');
    shown.forEach(function (x) {
      h.push('<button class="zz-row zz-brand' + (st.brands.indexOf(x.i) >= 0 ? ' act' : '') + '" data-i="' + x.i + '">' +
             '<span>' + E(x.b) + '</span><span class=zz-mut>' + x.c + '</span></button>');
    });
    h.push('</div>');
    h.push('</div>');
    return h.join('');
  };

  ZZ.prototype.hasAny = function () {
    var st = this.st;
    for (var k in st.facets) if (st.facets[k] && st.facets[k].length) return true;
    return !!(st.brands.length || st.subs.length || st.kat >= 0 || st.sc || st.pmin != null || st.pmax != null ||
              st.inStock || st.q || st.disc);
  };

  ZZ.prototype.facetBox = function (fi, res, vShtorke) {
    var f = this.d.f[fi], sel = this.st.facets[fi] || [], h = [];
    if (!res.facetCounts[fi]) return '';       // эту характеристику сейчас не считали
    var vals = f.v.map(function (v, i) { return { code: i + 1, v: v, c: res.facetCounts[fi][i + 1] }; })
                  .filter(function (x) { return x.c > 0 || sel.indexOf(x.code) >= 0; });
    if (!vals.length) return '';
    vals.sort(function (a, b) { return b.c - a.c || (a.v < b.v ? -1 : 1); });
    h.push('<div class="zz-box' + (vShtorke ? ' zz-shbox' : '') + '" data-f="' + fi + '">' +
           '<div class=zz-lbl>' + E(f.n) + (f.u ? ', ' + E(f.u) : '') + '</div><div class=zz-tree>');
    vals.slice(0, vShtorke ? 8 : 14).forEach(function (x) {
      h.push('<button class="zz-row zz-fv' + (sel.indexOf(x.code) >= 0 ? ' act' : '') + '" data-f="' + fi + '" data-c="' + x.code + '">' +
             '<span>' + E(x.v) + '</span><span class=zz-mut>' + x.c + '</span></button>');
    });
    h.push('</div></div>');
    return h.join('');
  };

  /* --- главная колонка ------------------------------------------------------ */
  ZZ.prototype.main = function (hits, res) {
    var d = this.d, sh = this.sh, h = [];
    var prosto = this.vid === 'prostoy';
    var perPage = prosto ? 24 : 240;

    var slice, pages = 1, from = 0;
    if (prosto) {
      if (!this.pokazano) this.pokazano = perPage;
      slice = hits.slice(0, this.pokazano);
    } else {
      pages = Math.max(1, Math.ceil(hits.length / perPage));
      if (this.page > pages) this.page = pages;
      from = (this.page - 1) * perPage;
      slice = hits.slice(from, from + perPage);
    }

    h.push('<div class=zz-main>');
    h.push(this.katNav(res));
    h.push('<div class=zz-bar><div class=zz-found><b>' + hits.length + '</b> ' + E(T('items')) + '</div>');
    h.push('<div class=zz-bar-r>' + (prosto ? '' : this.sortSel()) + this.vidSw());
    if (!prosto) {
      h.push('<div class=zz-sizes>');
      ['s', 'm', 'l', 'xl'].forEach(function (s) {
        h.push('<button class="zz-chip zz-size' + (this.size === s ? ' act' : '') + '" data-v="' + s + '">' + s.toUpperCase() + '</button>');
      }, this);
      h.push('</div>');
    } else {
      // телефон: разделы полки в бургере (слово владельца 15.10.2026), кнопка видна только < 900 px
      var dk = this.d.kt ? this.detiVetki(res) : [];
      if (dk.length && !(dk.length === 1 && dk[0].c === res.total)) {
        var kn = this.st.kat >= 0 && this.d.kt[this.st.kat] ? this.d.kt[this.st.kat][1] : T('cats');
        h.push('<button class="zz-chip zz-openk"><span class=zz-openk-ik aria-hidden=true></span>' + E(kn) + '</button>');
      }
      h.push('<button class="zz-chip zz-openf">' + E(T('filters')) + (this.skolkoUslovij() ? ' (' + this.skolkoUslovij() + ')' : '') + '</button>');
    }
    h.push('</div></div>');

    var fishki = this.hasAny() ? this.pickedChips() : '';
    if (fishki) h.push('<div class=zz-picked>' + fishki + '</div>');

    if (!slice.length) {
      h.push('<div class=zz-empty>' + E(T('empty')) + '</div>');
    } else {
      h.push('<div class="zz-grid zz-' + (prosto ? 'p' : this.size) + '">');
      slice.forEach(function (i) {
        var img = sh.imageAt(i, prosto ? 400 : (this.size === 'xl' ? 600 : this.size === 'l' ? 400 : 300));
        var dsc = d.d[i], hh = sh.handleAt(i), c = CENY[hh];
        // Пока Shopify не ответил — цена указателя в валюте покупателя с «≈».
        // Ответ приходит за доли секунды и подменяет её точной (см. ceny()).
        h.push('<a class=zz-card data-h="' + E(hh) + '" href="' + (this.opts.base || '/products/') + E(hh) + '">' +
               (dsc ? '<span class=zz-badge>−' + dsc + ' %</span>' : '') +
               (img && !sh.bezFoto(i) ? '<img loading=lazy src="' + E(img) + '" alt="' + E(d.t[i]) + '">'
                    : '<div class=zz-noimg aria-hidden=true><span>' + IKONKA + '</span></div>') +
               '<div class=zz-cbrand>' + E(d.brands[d.b[i]] || '') + '</div>' +
               '<div class=zz-title>' + E(c && c.t ? c.t : d.t[i]) + '</div>' +
               '<div class=zz-price>' + (c && c.p != null ? E(money(c.p)) : '<span class=zz-approx>≈ ' + E(money(vMestnuyu(d.p[i]))) + '</span>') +
               ((c ? c.a : sh.avail[i]) ? '' : ' <span class=zz-mut>· ' + E(T('on_order')) + '</span>') + '</div></a>');
      }, this);
      h.push('</div>');
    }

    if (prosto) {
      if (slice.length < hits.length) {
        h.push('<div class=zz-pager><button class=zz-eshe>' +
               E(T('show_more', { n: Math.min(perPage, hits.length - slice.length), t: hits.length })) + '</button></div>');
      }
    } else if (pages > 1) {
      h.push('<div class=zz-pager>' +
        '<button class="zz-pg' + (this.page > 1 ? '' : ' dis') + '" data-p="' + (this.page - 1) + '">' + E(T('back')) + '</button>' +
        '<span class=zz-mut>' + (from + 1) + '–' + Math.min(from + perPage, hits.length) + ' ' + E(T('of')) + ' ' + hits.length +
        ' · ' + E(T('pg')) + ' ' + this.page + '/' + pages + '</span>' +
        '<button class="zz-pg' + (this.page < pages ? '' : ' dis') + '" data-p="' + (this.page + 1) + '">' + E(T('next')) + '</button></div>');
    }
    h.push('<button class=zz-totop>' + E(T('top')) + '</button>');
    if (prosto) h.push('<div class="zz-mut zz-dbg"></div>');
    h.push('</div>');
    return h.join('');
  };

  ZZ.prototype.skolkoUslovij = function () {
    var st = this.st, n = 0;
    for (var k in st.facets) if (st.facets[k] && st.facets[k].length) n += st.facets[k].length;
    var scS = st.sc && window.ZZ_SCEN && window.ZZ_SCEN[st.sc] && window.ZZ_SCEN[st.sc].s;   // полки раздела — одно условие
    n += st.brands.length + (scS ? 0 : st.subs.length) + (st.kat >= 0 ? 1 : 0) + (st.sc ? 1 : 0);
    if (st.pmin != null || st.pmax != null) n++;
    if (st.inStock) n++;
    if (st.disc) n++;
    if (st.q) n++;
    return n;
  };

  /* 🔴 Фишки выбранного. Здесь же решается третье условие переключателя:
     фильтр по характеристике, которой в нынешнем виде НЕТ, не отменяется —
     он показывается фишкой с пометкой, что он из подробного вида. */
  ZZ.prototype.pickedChips = function () {
    var d = this.d, st = this.st, self = this, h = [];
    for (var fi in st.facets) {
      (st.facets[fi] || []).forEach(function (c) {
        var skryta = self.facetSkryta(fi);
        h.push('<button class="zz-tag' + (skryta ? ' zz-tag-skr' : '') + '" data-f="' + fi + '" data-c="' + c + '"' +
               (skryta ? ' title="' + E(T('hidden')) + '"' : '') + '>' +
               (skryta ? '⚙ ' : '') + E(d.f[fi].n) + ': ' + E(d.f[fi].v[c - 1]) + ' <span class=zz-kx aria-hidden=true>✕</span></button>');
      });
    }
    st.brands.forEach(function (i) { h.push('<button class=zz-tag data-b="' + i + '">' + E(d.brands[i]) + ' <span class=zz-kx aria-hidden=true>✕</span></button>'); });
    if (!(st.sc && window.ZZ_SCEN && window.ZZ_SCEN[st.sc] && window.ZZ_SCEN[st.sc].s)) st.subs.forEach(function (i) {
      h.push('<button class=zz-tag data-s="' + i + '">' + E(self.imyaRazdela(d.subs[i])) + ' <span class=zz-kx aria-hidden=true>✕</span></button>');
    });
    // ветка дерева фишкой не дублируется: она уже в пути над товарами с ✕ (обход 15.10.2026)
    if (st.kat >= 0 && d.kt && !this.opts.menu) h.push('<button class=zz-tag data-katx=1>' + E(d.kt[st.kat][1]) + ' <span class=zz-kx aria-hidden=true>✕</span></button>');
    if (st.pmin != null || st.pmax != null) {
      h.push('<button class=zz-tag data-price=1>' +
             (st.pmin != null ? E(money(vMestnuyu(st.pmin))) : '') + '–' + (st.pmax != null ? E(money(vMestnuyu(st.pmax))) : '') + ' <span class=zz-kx aria-hidden=true>✕</span></button>');
    }
    if (st.inStock) h.push('<button class=zz-tag data-stock=1>' + E(T('in_stock_tag')) + ' <span class=zz-kx aria-hidden=true>✕</span></button>');
    if (st.disc) h.push('<button class=zz-tag data-disc=1>' + E(T('disc_tag')) + ' ' + st.disc[0] + '–' + st.disc[1] + ' % <span class=zz-kx aria-hidden=true>✕</span></button>');
    if (st.q) h.push('<button class=zz-tag data-q=1>«' + E(st.q) + '» <span class=zz-kx aria-hidden=true>✕</span></button>');
    return h.join('');
  };

  /* --- окно «Ещё фильтры» (подробный вид) ----------------------------------- */
  /* 15.10.2026, владелец: «как выполнено More filters мне не нравится». Было: 40 свёрнутых строк, число в
     скобках — значения, а не товары; фильтры без выбора; дубли боковой колонки. Стало: карточки в колонках,
     в каждой сразу 6 частых значений с числом товаров и «ещё N»; только фильтры с выбором (≥2 значений) и
     которых нет слева; полезные (покрывают больше товаров) — первыми; кнопка с живым числом «Показать N». */
  ZZ.prototype.modalFi = function () {
    var d = this.d, res = this.res, st = this.st, sbok = {}, vis = this.vidimyeFacety(), out = [];
    for (var k = 0; k < Math.min(vis.length, this.opts.sideFacets || 8); k++) sbok[vis[k]] = 1;
    for (var fi = 0; fi < d.f.length; fi++) {
      if (sbok[fi] || !res.facetCounts[fi]) continue;
      var sel = st.facets[fi] || [], n = 0, zn = 0;
      for (var c = 1; c < res.facetCounts[fi].length; c++) {
        if (res.facetCounts[fi][c] > 0 || sel.indexOf(c) >= 0) { zn++; n += res.facetCounts[fi][c]; }
      }
      if (zn >= 2 || sel.length) out.push({ fi: fi, n: n });
    }
    out.sort(function (a, b) { return b.n - a.n; });
    return out;
  };

  ZZ.prototype.modal = function () {
    var d = this.d, res = this.res, h = [], self = this;
    h.push('<div class=zz-modal id=zz-modal><div class="zz-mbox zz-mbox-acc">' +
           '<div class=zz-mhead><b>' + E(T('m_head')) + '</b><button class=zz-mx aria-label="close">✕</button></div>' +
           '<input class="zz-inp zz-msearch" placeholder="' + E(T('m_search')) + '"><div class=zz-mbody>');
    // Как у ACC (слово владельца 16.10.2026): выбор фильтров — только внутри категории, не на весь
    // каталог. На странице всего отдела без выбранного раздела окно просит выбрать раздел.
    if (this.vseFacety && d.shelf === 'ВСЕ' && this.st.kat < 0) {
      // первый уровень = полки отдела (13), как первый уровень каталога ACC; ведут в подробный вид полки
      var koren = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', subs = d.subs || [];
      h.push('<p class=zz-mnet>' + E(T('vyb_kat')) + '</p><div class="zz-katnav zz-mpolki">');
      subs.map(function (hnd, i) { return { h: hnd, c: res.subCounts[i] || 0 }; })
          .filter(function (x) { return x.c > 0 && /^[a-z0-9-]+$/.test(x.h); })
          .sort(function (a, b) { return b.c - a.c; })
          .forEach(function (x) {
            h.push('<a class="zz-chip zz-katbtn" href="' + koren + 'collections/' + x.h + '?view=zz-shelf&vid=podrobnyy">' +
                   E(self.imyaRazdela(x.h)) + ' <span class=zz-mut>' + x.c + '</span></a>');
          });
      h.push('</div>');
    } else if (this.vseFacety) {
      var standart = this.standartFacety(), dop = this.dopFacety(), spisok = [];
      d.f.forEach(function (f, fi) {
        if (standart.indexOf(fi) >= 0 || !res.facetCounts[fi]) return;
        var n = 0, zn = 0;
        for (var c = 1; c < res.facetCounts[fi].length; c++) if (res.facetCounts[fi][c] > 0) { zn++; n += res.facetCounts[fi][c]; }
        if (zn >= 2 || dop.indexOf(fi) >= 0) spisok.push({ fi: fi, n: n, imya: f.n + (f.u ? ', ' + f.u : '') });
      });
      spisok.sort(function (a, b) { return a.imya.localeCompare(b.imya, LANG); });
      h.push('<div class=zz-mgrid>');
      spisok.forEach(function (x) {
        h.push('<label class=zz-mpunkt data-name="' + E(x.imya.toLowerCase()) + '"><input type=checkbox class=zz-mpin data-f="' + x.fi + '"' +
               (dop.indexOf(x.fi) >= 0 ? ' checked' : '') + '><span>' + E(x.imya) + ' <span class=zz-mut>(' + x.n + ')</span></span></label>');
      });
      h.push('</div>');
    }
    h.push('</div><div class=zz-mfoot><button class="zz-chip zz-motmena">' + E(T('otmena')) + '</button>' +
           '<button class="zz-chip act zz-msave">' + E(T('sohr')) + '</button></div></div></div>');
    return h.join('');
  };

  ZZ.prototype.modalFacety = function () {
    var r = this.root, f = {}, k;
    for (k in this.st.facets) if ((this.modalSpisok || []).indexOf(+k) < 0) f[k] = this.st.facets[k].slice();
    Array.prototype.forEach.call(r.querySelectorAll('.zz-mv'), function (el) {
      if (el.checked) (f[el.dataset.f] = f[el.dataset.f] || []).push(+el.dataset.c);
    });
    return f;
  };

  /* --- бургер разделов на телефоне ------------------------------------------- */
  // Слово владельца 15.10.2026 (снимки с телефона): «чипы 2 группы и мало понятно что есть что»,
  // «бургер меню? … про версию на телефоне». На телефоне ряд разделов убран, вместо него кнопка
  // «☰ Разделы» у «Фильтров»; шторка — тот же список, что слева в подробном виде, целиком.
  ZZ.prototype.katShtorkaHtml = function (res) {
    if (!this.d.kt) return '';
    var bylo = this.katOtkr;
    this.katOtkr = { d: 1, a: 1, v: 1 };
    var spisok = this.derevoBox(res);
    this.katOtkr = bylo;
    return '<div class="zz-sheet zz-ksheet' + (this.katShtorka ? ' open' : '') + '" id=zz-ksheet><div class=zz-sheetbox>' +
           '<div class=zz-shhead><b>' + E(T('cats')) + '</b><button class=zz-kshx>✕</button></div>' +
           '<div class=zz-shbody>' + spisok + '</div></div></div>';
  };

  /* --- шторка снизу (простой вид) ------------------------------------------- */
  ZZ.prototype.shtorkaHtml = function (res) {
    var h = [];
    h.push('<div class="zz-sheet' + (this.shtorka ? ' open' : '') + '" id=zz-sheet><div class=zz-sheetbox>');
    h.push('<div class=zz-shhead><b>' + E(T('filters')) + '</b><button class=zz-shx>✕</button></div>');
    h.push('<div class=zz-shbody>');
    h.push('<div class="zz-box zz-shbox"><input class="zz-inp zz-q" placeholder="' + E(T('q_ph')) + '" value="' + E(this.st.q) + '"></div>');
    h.push('<div class="zz-box zz-shbox"><button class="zz-avail' + (this.st.inStock ? ' on' : '') + '">' +
           (this.st.inStock ? '✓ ' : '') + E(T('only_stock')) + ' <span class=zz-mut>(' + res.inStockCount + ')</span></button></div>');
    h.push(this.cenaBox(res).replace('class=zz-box', 'class="zz-box zz-shbox"'));
    h.push(this.skidkaBox(false).replace('class=zz-box', 'class="zz-box zz-shbox"'));
    h.push(this.derevoBox(res).replace('class=zz-box', 'class="zz-box zz-shbox"'));
    h.push(this.brendBox(res, 10, true).replace('class=zz-box', 'class="zz-box zz-shbox"'));
    // 16.10.2026, слово владельца: «в Simple режиме всегда это окно с непонятной системой фильтров».
    // Как у ACC: основные фильтры, затем несколько главных и выбранные покупателем, ниже — «Больше фильтров».
    this.sbokFacety().forEach(function (fi) { h.push(this.facetBox(fi, res, true)); }, this);
    var rest = this.d.f.length - this.sbokFacety().length;
    h.push('<div class="zz-box zz-shbox"><button class=zz-more>' + E(T('more_f')) +
           (rest > 0 ? ' <span class=zz-mut>(' + rest + ')</span>' : '') + '</button></div>');
    h.push('</div>');
    // 🔴 «Показать N товаров»: N считается на лету — человек видит итог
    // до того, как закроет шторку.
    h.push('<div class=zz-shfoot>' +
           (this.hasAny() ? '<button class="zz-chip zz-reset">' + E(T('clear')) + '</button>' : '') +
           '<button class="zz-chip act zz-shapply">' + E(T('show_n', { n: res.total })) + '</button></div>');
    h.push('</div></div>');
    return h.join('');
  };

  /* --- события -------------------------------------------------------------- */
  ZZ.prototype.bind = function () {
    var self = this, r = this.root;
    var on = function (sel, ev, fn) {
      Array.prototype.forEach.call(r.querySelectorAll(sel), function (el) { el.addEventListener(ev, fn); });
    };
    var toggle = function (arr, v) {
      var i = arr.indexOf(v);
      if (i >= 0) arr.splice(i, 1); else arr.push(v);
      return arr;
    };

    on('.zz-vidbtn', 'click', function () { self.smenitVid(this.dataset.v); });
    on('.zz-sort', 'click', function () { self.sort = this.dataset.v; self.apply(); });
    on('.zz-sortv', 'change', function () { self.sort = this.value; self.apply(); });
    on('.zz-size', 'click', function () { self.size = this.dataset.v; self.pomnit('zz-size', self.size); self.render(); });
    on('.zz-avail', 'click', function () { self.st.inStock = !self.st.inStock; self.apply(); });
    on('.zz-suball', 'click', function () { self.st.subs = []; self.st.kat = -1; self.st.sc = ''; self.apply(); });
    on('[data-scx]', 'click', function () { if (window.ZZ_SCEN[self.st.sc] && window.ZZ_SCEN[self.st.sc].s) self.st.subs = []; self.st.sc = ''; self.st.kat = -1; self.apply(); });
    on('[data-kat]', 'click', function () { self.st.kat = +this.dataset.kat; self.katOtkr = {}; self.katGr = null; self.katShtorka = false; self.vseFacety = false; self.apply(); });
    on('.zz-kattab', 'click', function () { self.katGr = this.dataset.kg; self.render(); });
    on('.zz-katmore', 'click', function () {
      self.katOtkr = self.katOtkr || {}; self.katOtkr[this.dataset.gr] = !self.katOtkr[this.dataset.gr]; self.render();
    });
    on('.zz-sub', 'click', function () { toggle(self.st.subs, +this.dataset.i); self.apply(); });
    on('.zz-krumb[data-s]', 'click', function () { toggle(self.st.subs, +this.dataset.s); self.apply(); });
    on('.zz-brand', 'click', function () { toggle(self.st.brands, +this.dataset.i); self.apply(); });
    on('.zz-bmore', 'click', function () { self.brandOpen = !self.brandOpen; self.render(); });
    on('.zz-bq', 'input', function () {
      self.brandQuery = this.value; var pos = this.selectionStart; self.render();
      var el = r.querySelector('.zz-bq'); if (el) { el.focus(); try { el.setSelectionRange(pos, pos); } catch (e) {} }
    });
    on('.zz-fv', 'click', function () {
      var fi = this.dataset.f, c = +this.dataset.c;
      self.st.facets[fi] = toggle(self.st.facets[fi] || [], c);
      self.apply();
    });
    on('.zz-disc', 'click', function () {
      var lo = +this.dataset.lo, hi = +this.dataset.hi;
      self.st.disc = (self.st.disc && self.st.disc[0] === lo && self.st.disc[1] === hi) ? null : [lo, hi];
      self.apply();
    });
    on('.zz-q', 'change', function () { self.st.q = this.value; self.apply(); });
    on('.zz-q', 'keydown', function (e) { if (e.key === 'Enter') { self.st.q = this.value; self.apply(); } });
    on('#zz-pgo', 'click', function () {
      var a = r.querySelector('.zz-pmin').value, b = r.querySelector('.zz-pmax').value;
      self.st.pmin = a === '' ? null : izMestnoy(parseFloat(a) * 100);
      self.st.pmax = b === '' ? null : izMestnoy(parseFloat(b) * 100);
      self.apply();
    });
    on('.zz-pg', 'click', function () {
      if (this.classList.contains('dis')) return;
      self.page = +this.dataset.p; self.pokazano = 0; self.writeUrl(true); self.render();
      if (self.root.scrollIntoView) self.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    on('.zz-eshe', 'click', function () { self.pokazano += 24; self.render(); });
    on('.zz-totop', 'click', function () { try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {} });
    on('.zz-reset', 'click', function () { self.st = self.pustoe(); self.shtorka = false; self.apply(); });
    on('.zz-tag', 'click', function () {
      var ds = this.dataset;
      if (ds.f != null) self.st.facets[ds.f] = toggle(self.st.facets[ds.f] || [], +ds.c);
      else if (ds.b != null) toggle(self.st.brands, +ds.b);
      else if (ds.s != null) toggle(self.st.subs, +ds.s);
      else if (ds.katx) self.st.kat = -1;
      else if (ds.price) { self.st.pmin = null; self.st.pmax = null; }
      else if (ds.stock) self.st.inStock = false;
      else if (ds.disc) self.st.disc = null;
      else if (ds.q) self.st.q = '';
      self.apply();
    });

    // шторка простого вида
    var sheet = r.querySelector('#zz-sheet');
    if (sheet) {
      on('.zz-openf', 'click', function () { self.shtorka = true; self.render(); });
      on('.zz-openk', 'click', function () { self.katShtorka = true; self.render(); });
      on('.zz-kshx', 'click', function () { self.katShtorka = false; self.render(); });
      var ks = r.querySelector('#zz-ksheet');
      if (ks) ks.addEventListener('click', function (e) { if (e.target === ks) { self.katShtorka = false; self.render(); } });
      on('.zz-shx', 'click', function () { self.shtorka = false; self.render(); });
      on('.zz-shapply', 'click', function () { self.shtorka = false; self.render(); });
      sheet.addEventListener('click', function (e) { if (e.target === sheet) { self.shtorka = false; self.render(); } });
    }

    // окно «Ещё фильтры» подробного вида
    var modal = r.querySelector('#zz-modal');
    if (modal) {
      on('.zz-more', 'click', function () {
        // окно показывает все характеристики — значит и числа нужны по всем
        self.vseFacety = true;
        self.render();
        var m2 = self.root.querySelector('#zz-modal');
        if (m2) m2.classList.add('open');
      });
      on('.zz-mx', 'click', function () {
        modal.classList.remove('open'); self.vseFacety = false;
      });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) { modal.classList.remove('open'); self.vseFacety = false; }
      });
      on('.zz-msearch', 'input', function () {
        var q = this.value.toLowerCase();
        Array.prototype.forEach.call(r.querySelectorAll('.zz-mpunkt'), function (el) {
          el.style.display = !q || el.dataset.name.indexOf(q) >= 0 ? '' : 'none';
        });
      });
      on('.zz-motmena', 'click', function () { modal.classList.remove('open'); self.vseFacety = false; });
      on('.zz-msave', 'click', function () {
        var dop = [];
        Array.prototype.forEach.call(r.querySelectorAll('.zz-mpin'), function (el) { if (el.checked) dop.push(+el.dataset.f); });
        self.dop = dop;
        try { localStorage.setItem(self.dopKlyuch(), JSON.stringify(dop)); } catch (e) {}
        modal.classList.remove('open');
        self.vseFacety = false;
        self.apply();
      });
    }
  };

  // окно «Больше фильтров» как у ACC (снимок владельца 16.10.2026): кнопки «Отмена / Сохранить»
  var OKNO_T = { en: ['Cancel', 'Save'], ru: ['Отмена', 'Сохранить'], et: ['Tühista', 'Salvesta'], de: ['Abbrechen', 'Speichern'],
                 fr: ['Annuler', 'Enregistrer'], nl: ['Annuleren', 'Opslaan'], no: ['Avbryt', 'Lagre'], fi: ['Peruuta', 'Tallenna'], es: ['Cancelar', 'Guardar'] };
  var VYB_KAT = { en: 'Choose a category first: each category has its own filters.',
                  ru: 'Сначала выберите раздел: у каждого раздела свои фильтры.',
                  et: 'Valige kõigepealt kategooria: igal kategoorial on oma filtrid.',
                  de: 'Wählen Sie zuerst eine Kategorie: jede Kategorie hat eigene Filter.',
                  fr: 'Choisissez d\'abord une catégorie : chaque catégorie a ses propres filtres.',
                  nl: 'Kies eerst een categorie: elke categorie heeft eigen filters.',
                  no: 'Velg en kategori først: hver kategori har egne filtre.',
                  fi: 'Valitse ensin kategoria: jokaisella kategorialla on omat suodattimensa.',
                  es: 'Elige primero una categoría: cada categoría tiene sus propios filtros.' };
  for (var ol in OKNO_T) if (SLOVA[ol]) { SLOVA[ol].otmena = OKNO_T[ol][0]; SLOVA[ol].sohr = OKNO_T[ol][1]; SLOVA[ol].vyb_kat = VYB_KAT[ol]; }

  window.ZZShelfUI = ZZ;

  window.zzMountShelf = function (rootSel, indexUrl, opts) {
    var root = document.querySelector(rootSel);
    if (!root) return;
    if (opts && opts.lang && SLOVA[opts.lang]) LANG = opts.lang;
    root.innerHTML = '<div class=zz-loading>' + E(T('loading')) + '</div>';
    var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
    // перевод — отдельный маленький файл; не пришёл — остаёмся на английском
    var trP = (opts && opts.perevodUrl)
      ? fetch(opts.perevodUrl, { credentials: 'omit' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
      : Promise.resolve(null);
    Promise.all([
      fetch(indexUrl, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }),
      trP
    ])
      .then(function (both) {
        var doc = both[0];
        perevesti(doc, both[1], LANG);
        var tLoad = ((window.performance && performance.now) ? performance.now() : Date.now()) - t0;
        var z = new ZZ(root, doc, opts);
        var dbg = root.querySelector('.zz-dbg');
        if (dbg) dbg.textContent += ' · загрузка+разбор ' + tLoad.toFixed(0) + ' мс';
        window.zzShelf = z;
      })
      .catch(function (e) {
        // Указатель лежит на стороне Shopify. Не пришёл — значит отказал сам
        // Shopify либо сеть покупателя, но не наш сервер: его тут нет.
        root.innerHTML = '<div class=zz-empty>' + E(T('fail', { e: e.message })) + '</div>';
      });
  };
})();
